/**
 * 呼吸异常指数中的持续片段图
 */
export default function getEchartsOptionLineB1(series_data) {
	let option = {
		grid: {
			x: 0,
			y: 0,
			x2: 0,
			y2: 0
		},
		xAxis: {
			type: 'category',
			show: false
		},
		yAxis: {
			type: 'value',
			show: false
		},
		series: [
			{
				data: series_data,
				type: 'line',
				smooth: true,
				symbolSize: 0,
				itemStyle: {
					color: 'rgba(74, 124, 232, 1)'
				},
				lineStyle: {
					width: 1
				},
				emphasis: {
					scale: 1.5
				}
			}
		]
	};
	return option;
}